import React, { useContext, useEffect, useReducer, useState } from 'react';
import UserContext from '../../../context/UserContext.js';
import CuadroEditableCantidadParticipantes from './CuadroEditableCantidadParticipantes.js';
import EditarItemLista from '../../edicion/EditarItemLista.js';
import CuadroTablaInsertable from '../../UI/CuadroTablaInsertable.js';
import * as ReducerEdicion from '../../reducers/ReducerEdicionLista.js';
import * as ReducerData from '../../reducers/ReducerDataAccess.js';
import * as ModoEdicion from '../../constantes/ModoEdicion.js';
import * as Data from '../../edicion/data/DataTorneoParticipantes.js';
import * as DTOs from '../../edicion/DTOs/TorneoParticipantesDTOs.js';
import * as Funciones from '../../edicion/funciones/FuncionesTorneoParticipantes.js';
import * as TipoParticipacion from '../../constantes/TipoParticipacionTorneo.js';
import * as TipoEquipo from '../../constantes/TipoEquipo.js';
import useGetListaURL from '../../../hooks/useGetListaURL.js';
import styles from '../../edicion/CuadroListaEditable.module.css';
import MensajeGrabando from '../../UI/MensajeGrabando.js';

const ParticipantesTorneo = (props) => {
  const torneo = props.datosElegidos?.torneo;
  const idTorneo = torneo?.id;
  const { usuario } = useContext(UserContext);
  const puedeEditar = usuario && usuario.puedeEditar;
  const [equiposDisponibles, setEquiposDisponibles] = useState(null);
  const [itemsEditando, setItemsEditando] = useState({});
  const { fetchData } = useGetListaURL();

  const [datos, setDatos] = useReducer(
    ReducerEdicion.reducerEdicionLista,
    ReducerEdicion.ReducerVacio
  );
  const [dataAccess, setDataAccess] = useReducer(
    ReducerData.reducerDataAccess,
    ReducerData.ReducerVacio
  );

  // Cargar equipos disponibles una sola vez
  useEffect(() => {
    if (!torneo || !torneo.categoria) {
      setEquiposDisponibles([]);
      return;
    }

    const tipoParticipacion = torneo.tipoTorneo?.tipoParticipacion;
    let url = null;

    // Si es torneo de SELECCIONES, cargar todas las selecciones de la categoría
    if (tipoParticipacion === TipoParticipacion.SELECCIONES) {
      url = 'equipos?categoria=' + torneo.categoria.codigo + '&tipo=' + TipoEquipo.SELECCION;
    }
    // Si es torneo de CLUBES de un país, cargar equipos del país
    else if (
      torneo.pais &&
      (tipoParticipacion === TipoParticipacion.CLUBES ||
        tipoParticipacion === TipoParticipacion.PAIS ||
        tipoParticipacion === TipoParticipacion.REGION)
    ) {
      url =
        'paises/' +
        torneo.pais.id +
        '/equipos?categoria=' +
        torneo.categoria.codigo +
        '&tipo=' +
        TipoEquipo.CLUB;
      if (torneo.anioInicio) {
        url += '&anio=' + torneo.anioInicio;
      }
    }

    if (url) {
      fetchData(url, setEquiposDisponibles);
    } else {
      setEquiposDisponibles([]);
    }
  }, [torneo, fetchData]);

  useEffect(() => {
    const cargarLista = async () => {
      setDataAccess({ type: ReducerData.Accion.CARGANDO, value: true });
      try {
        const lista = await Data.GetListaItems(idTorneo);
        if (lista && lista !== Promise.resolve(lista)) {
          const listaOrdenada = [...lista].sort((a, b) => Funciones.OrdenarLista(a, b));
          setDatos({ type: ReducerEdicion.Tipo.LISTA, value: listaOrdenada });
        }
        setDataAccess({ type: ReducerData.Accion.LIMPIAR, value: null });
      } catch (error) {
        setDataAccess({ type: ReducerData.Accion.ERRORES, value: [error.message] });
      }
    };
    if (idTorneo === null) {
      setDatos({ type: ReducerEdicion.Tipo.BORRAR, value: null });
      setDataAccess({ type: ReducerData.Accion.LIMPIAR, value: null });
    } else {
      cargarLista();
    }
  }, [idTorneo]);

  const onCampoChange = (item) => {
    setDatos({ type: ReducerEdicion.Tipo.UPDATE_ITEM, value: item });
  };

  const onEditarItem = async (idItem) => {
    try {
      const itemElegido = await Data.GetItem(idTorneo, idItem);
      if (itemElegido && itemElegido !== Promise.resolve(itemElegido)) {
        setItemsEditando((prev) => ({ ...prev, [idItem]: itemElegido }));
      }
    } catch (error) {
      setDataAccess({ type: ReducerData.Accion.ERRORES, value: [error.message] });
    }
  };

  const onEliminarItem = async (idItem) => {
    const eliminar = window.confirm('¿Está seguro que desea eliminarlo?');
    if (eliminar) {
      setDataAccess({ type: ReducerData.Accion.GRABANDO, value: true });
      try {
        await Data.DeleteItem(idTorneo, idItem);
        onItemEliminado(idItem);
        setDataAccess({ type: ReducerData.Accion.LIMPIAR, value: null });
      } catch (error) {
        setDataAccess({ type: ReducerData.Accion.ERRORES, value: [error.message] });
      }
    } else {
      setDataAccess({ type: ReducerData.Accion.LIMPIAR, value: null });
    }
  };

  const onInsertarItem = () => {
    let nuevoItem = DTOs.ItemVacio(idTorneo);
    setDatos({ type: ReducerEdicion.Tipo.INSERTAR, value: nuevoItem });
    setDataAccess({ type: ReducerData.Accion.LIMPIAR, value: null });
  };

  const onGuardarNuevo = async (item) => {
    const error = Funciones.ValidarItemGrabar(item);
    if (error !== '') {
      throw new Error(error);
    }

    setDataAccess({ type: ReducerData.Accion.GRABANDO, value: true });
    try {
      const idNuevo = await Data.PostItem(idTorneo, item);
      const itemGrabado = { ...item, id: idNuevo };
      // Append directly: listaActualizada sólo agrega cuando modo===INSERTAR,
      // pero en las filas de edición rápida el modo es OCULTAR.
      const listaNueva = [...(datos.lista || []), itemGrabado];
      const listaOrdenada = listaNueva.sort((a, b) => Funciones.OrdenarLista(a, b));
      setDatos({ type: ReducerEdicion.Tipo.LISTA_ACTUALIZADA, value: listaOrdenada });
      setDataAccess({ type: ReducerData.Accion.LIMPIAR, value: null });
    } catch (error) {
      setDataAccess({ type: ReducerData.Accion.ERRORES, value: [error.message] });
      throw error;
    }
  };

  const onItemEliminado = (idEliminado) => {
    let nombres = ReducerEdicion.eliminarItemLista(datos, idEliminado);
    setDatos({ type: ReducerEdicion.Tipo.LISTA_ACTUALIZADA, value: nombres });
  };

  const onItemGrabado = (itemGrabado) => {
    let listaNueva = ReducerEdicion.listaActualizada(datos, itemGrabado);
    const listaOrdenada = listaNueva.sort((a, b) => Funciones.OrdenarLista(a, b));
    setDatos({ type: ReducerEdicion.Tipo.LISTA_ACTUALIZADA, value: listaOrdenada });
  };

  const onCancelarEditarItem = () => {
    setDatos({ type: ReducerEdicion.Tipo.CANCELAR, value: null });
    setDataAccess({ type: ReducerData.Accion.LIMPIAR, value: null });
  };

  const onCancelarEdicionItem = (idItem) => {
    if (idItem) {
      setItemsEditando((prev) => {
        const nuevo = { ...prev };
        delete nuevo[idItem];
        return nuevo;
      });
    }
  };

  const onGuardarEdicion = async (item) => {
    const error = Funciones.ValidarItemGrabar(item);
    if (error !== '') throw new Error(error);
    setDataAccess({ type: ReducerData.Accion.GRABANDO, value: true });
    try {
      await Data.PutItem(idTorneo, item);
      // Reemplazar directamente en la lista (no depende de datos.modo)
      const listaNueva = (datos.lista || []).map((i) =>
        Number(i.id) === Number(item.id) ? item : i
      );
      const listaOrdenada = listaNueva.sort((a, b) => Funciones.OrdenarLista(a, b));
      setDatos({ type: ReducerEdicion.Tipo.LISTA_ACTUALIZADA, value: listaOrdenada });
      setItemsEditando((prev) => {
        const nuevo = { ...prev };
        delete nuevo[item.id];
        return nuevo;
      });
      setDataAccess({ type: ReducerData.Accion.LIMPIAR, value: null });
    } catch (error) {
      setDataAccess({ type: ReducerData.Accion.ERRORES, value: [error.message] });
      throw error;
    }
  };

  const onGuardarTodo = async (newItems = [], editedItems = []) => {
    if (newItems.length === 0 && editedItems.length === 0) return;
    setDataAccess({ type: ReducerData.Accion.GRABANDO, value: true });
    try {
      // Actualizar participantes existentes (PUT)
      const savedEdited = [];
      for (const item of editedItems) {
        const error = Funciones.ValidarItemGrabar(item);
        if (error !== '') continue;
        await Data.PutItem(idTorneo, item);
        savedEdited.push(item);
      }

      // Crear nuevos participantes (POST)
      const savedNew = [];
      for (const item of newItems) {
        const error = Funciones.ValidarItemGrabar(item);
        if (error !== '') continue;
        const idNuevo = await Data.PostItem(idTorneo, item);
        savedNew.push({ ...item, id: idNuevo });
      }

      // Una única actualización de la lista con todos los cambios
      if (savedEdited.length > 0 || savedNew.length > 0) {
        const savedMap = savedEdited.reduce((acc, i) => {
          acc[Number(i.id)] = i;
          return acc;
        }, {});
        const listaNueva = [
          ...(datos.lista || []).map((i) => savedMap[Number(i.id)] ?? i),
          ...savedNew,
        ];
        const listaOrdenada = listaNueva.sort((a, b) => Funciones.OrdenarLista(a, b));
        setDatos({ type: ReducerEdicion.Tipo.LISTA_ACTUALIZADA, value: listaOrdenada });
      }

      // Quitar de itemsEditando los registros guardados
      if (savedEdited.length > 0) {
        setItemsEditando((prev) => {
          const nuevo = { ...prev };
          for (const item of savedEdited) delete nuevo[item.id];
          return nuevo;
        });
      }

      setDataAccess({ type: ReducerData.Accion.LIMPIAR, value: null });
    } catch (error) {
      setDataAccess({ type: ReducerData.Accion.ERRORES, value: [error.message] });
      throw error;
    }
  };

  // Contexto con torneo y equipos disponibles
  const contexto = { torneo, equiposDisponibles };

  return (
    <React.Fragment>
      <CuadroEditableCantidadParticipantes datosElegidos={props.datosElegidos} />

      <CuadroTablaInsertable
        titulo="Participantes"
        isCargando={dataAccess.cargando}
        errores={dataAccess.errores}
        onInsertar={onInsertarItem}
      >
        {!dataAccess.cargando && (
          <table className={`${styles.tablaDatos}`}>
            <tbody>
              {Funciones.armarFilasTabla(
                datos.lista,
                null,
                onEditarItem,
                onEliminarItem,
                contexto,
                puedeEditar ? onGuardarNuevo : null,
                puedeEditar ? onGuardarTodo : null,
                puedeEditar ? itemsEditando : {},
                puedeEditar ? onGuardarEdicion : null,
                onCancelarEdicionItem
              )}
            </tbody>
          </table>
        )}
        <MensajeGrabando isGrabando={dataAccess.grabando} />
        {puedeEditar && datos.modo === ModoEdicion.INSERTAR && (
          <EditarItemLista
            tipo={null}
            idPadre={idTorneo}
            modo={datos.modo}
            item={datos.itemEdicion}
            actualizar={datos.actualizarItem}
            funciones={Funciones}
            data={Data}
            contexto={contexto}
            onCampoChange={onCampoChange}
            onItemGrabado={onItemGrabado}
            onItemEliminado={onItemEliminado}
            onCancelar={onCancelarEditarItem}
          />
        )}
      </CuadroTablaInsertable>
    </React.Fragment>
  );
};

export default ParticipantesTorneo;
